import React from 'react'
import { trans } from '../../../../_providers/Translation'

function Filter(props) {

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    return (
        <form className="filter-standard">
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1" selected>
                        {trans('filters.name')}
                    </option>
                    <option value="2">
                        {trans('filters.email')}
                    </option>
                    <option value="3">
                        {trans('filters.phone')}
                    </option>
                    <option value="4">
                        {trans('filters.address')}
                    </option>
                    <option value="5">
                        {trans('filters.active')}
                    </option>
                    <option value="6">
                        {trans('filters.superPartner')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="1">

                <input
                    type="search"
                    name="name"
                    onKeyUp={(e) => props.handleSearch(e.target.name, e.target.value)}
                    onChange={(e) => props.handleSearch(e.target.name, e.target.value)}
                    value={props.filters.name}
                    placeholder={trans('labels.search')}
                />
            </div>

        </form>
    )
}

export default Filter